import {
    THANALISTAGENTFORPARTNER_SUCCESS,
    THANALISTAGENTFORPARTNER_FAILED,
    RESET_THANALISTAGENTFORPARTNER,
    LOADING_THANALISTAGENTFORPARTNER,
    NETWORK_ERROR_THANALISTAGENTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_THANALISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case THANALISTAGENTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case THANALISTAGENTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_THANALISTAGENTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_THANALISTAGENTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};